import { ZfDropdown, ZfDropdownItem } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useEnabledDomiciles } from '../../api';
import { useYwuApp } from '../../contexts/ywu-app-context';
import { wnSendTrace } from '../../utils/wn-event-utils';

const defaultOption = 'Global';

export const DomicileSwitch: FunctionComponent = () => {
    const { activeDomicile, setActiveDomicile } = useYwuApp();

    const { data: enabledDomiciles } = useEnabledDomiciles();

    const handleChangeDomicile = (isoAlpha2: string) => {
        const isoAlpha = enabledDomiciles?.find((domicile) => domicile.isoAlpha2 === isoAlpha2)?.isoAlpha2;
        // undefined isoAlpha doesn't trigger the activeDomicileIsoAlpha2Selector reducer => return empty '' instead for Global domicile
        setActiveDomicile(isoAlpha || '');
        wnSendTrace({ feature: 'general', tags: { partnerUuid: '', action: 'change-domicile', domicile: isoAlpha || defaultOption } });
    };

    const options = [
        ...(enabledDomiciles?.map((domicile) => ({ value: domicile.isoAlpha2, label: domicile.countryName })) ?? []),
        { value: defaultOption, label: defaultOption },
    ];
    const activeDomicileLabel = options.find((option) => option.value === `${activeDomicile}`)?.label || defaultOption;

    return (
        <ZfDropdown text={activeDomicileLabel} icon="arrow_drop_down" hierarchy="tertiary" size="medium">
            {options.map((option) => (
                <ZfDropdownItem
                    state={`${activeDomicile}` === option.value ? 'active' : 'default'}
                    key={option.value}
                    label={option.label}
                    onDropdownItemSelect={() => handleChangeDomicile(option.value)}
                />
            ))}
        </ZfDropdown>
    );
};
